import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { NewTablesModule } from '../core-ui/NewTable/NewTable.module';
import { ResultsTableComponent } from './ResultsTable.component';

@NgModule({
    imports: [CommonModule, CoreUiModule, NewTablesModule],
    declarations: [ResultsTableComponent],
    exports: [ResultsTableComponent],
    providers: []
})
export class GenericComponentsModule {}
